export default function AttentionDeficitIcon({
  stroke = "#626060",
  fill = "#626060",
}: {
  stroke?: string;
  fill?: string;
}) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.7593 4.1748C10.5757 4.75037 10.4761 5.36356 10.4761 6C10.4761 9.31364 13.1625 11.9999 16.4761 12C17.7595 12 18.9478 11.5954 19.9233 10.9092C19.9568 11.2022 19.9761 11.4993 19.9761 11.7998V12.2998L18.0767 19.5996L18.9761 22.7998C19.0761 23.2998 18.7759 23.8 18.2759 24H8.97607C8.37624 23.9999 7.97608 23.5999 7.97607 23V21H6.97607C5.87621 20.9998 4.97608 20.0999 4.97607 19V17H3.97607C3.87598 17 3.67657 16.9996 3.57666 16.7998C3.07666 16.5998 2.87666 16 3.07666 15.5L4.97607 11.5C4.97607 9.5 5.77627 7.49961 7.17627 6.09961C8.19273 5.15096 9.43923 4.47909 10.7593 4.1748Z"
        fill={fill}
      />
      <path
        d="M16.4771 1.7002C18.8519 1.7002 20.7769 3.62518 20.7769 6C20.7769 8.37482 18.8519 10.2998 16.4771 10.2998C14.1022 10.2998 12.1772 8.37482 12.1772 6C12.1772 3.62518 14.1022 1.7002 16.4771 1.7002Z"
        stroke={stroke}
        strokeWidth="1.4"
      />
      <path
        d="M16.4771 3.7002C17.7473 3.7002 18.7769 4.72975 18.7769 6C18.7769 7.27025 17.7473 8.2998 16.4771 8.2998C15.2068 8.2998 14.1772 7.27025 14.1772 6C14.1772 4.72975 15.2068 3.7002 16.4771 3.7002Z"
        stroke={stroke}
        strokeWidth="1.4"
      />
    </svg>
  );
}
